import { useEffect, useState } from "react";

/**
 * Returns `value` once it has stopped changing for `delay` ms.
 * Each change restarts the timer, so rapid updates only emit the final value.
 */
export function useDebouncedValue<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
